import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { HasError, AlertError, AlertErrors, AlertSuccess } from 'vform'
import Pagination from 'laravel-vue-pagination'

import VueLazyload from 'vue-lazyload'

import VueCtkDateTimePicker from 'vue-ctk-date-time-picker';
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css';

import $ from 'jquery'

import 'bootstrap'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

import './bootstrap.js'

window.$ = $;
Vue.config.productionTip = false

window.pubkey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAgxUxFOwLhD/qPOghmsiv
ZrLNFqP6J1Rp2CTKZY+2WTo6vGc78A307voNygIzeezfR/QPBsH9nRYDPonM/cRR
nBzfCnUHNQw9YDp9V7Q7ym/yphppbFDliWjzqpL+fkijYb+jQ7TwI9K+NlSPxY5v
ARh52Sgk0D/IdfstvgM8eWIIwXvqlyWuupdypeMx9xednmx/2r08euSLVTwrHnMh
EVcJ1KKDEqLDjKM7Pnm9LA4tIdBOXg5K/qLAkEOa/ChJ1mp1vJYJ6y+EOYHcJhoX
yibtEoFmXx3SdJZkF2WXICFTRujomifisM5Z5g1sO/0CTlDzNHact6s32OUfE3Ss
RQIDAQAB
-----END PUBLIC KEY-----`

Vue.component(HasError.name, HasError)
Vue.component(AlertError.name, AlertError)
Vue.component(AlertErrors.name, AlertErrors)
Vue.component(AlertSuccess.name, AlertSuccess)
Vue.component('pagination', Pagination)

Vue.component('date-time-picker', VueCtkDateTimePicker);

Vue.use(VueLazyload, {
  preLoad: 1.3,
  attempt: 1,
  error: '/img/lazy/error.gif',
  loading: '/img/lazy/loading.gif',
})

Vue.filter('formatMoney', function(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(value);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// const app = new Vue({
//   el: '#app',
//   router,
//   render: h => h(App),
//   components: { App }
// })
